import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import download from '../images/download-doc.svg';
import Divider from '@mui/material/Divider';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { Button, IconButton, InputLabel, Select, MenuItem, FormControl } from '@mui/material';
import EnhancedTableHead from './EnhancedTableHead.index';
import moment from 'moment-timezone';
import { withTranslation } from 'react-i18next';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return true;
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const styles = (theme) => ({
  root: {
    width: '100%',
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10',
  },
  padding10px: {
    padding: '10px',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper: {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  hidden: {
    display: 'none',
  },
});

let BoxUtitlizationFilterObj = {
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  searchtext: '',
  tableName: '',
  group_id: null
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class KioskBoxUtilization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'desc',
      orderBy: 'created_on',
      page: 0,
      rowsPerPage: 10,
      fromdate: null,
      todate: null,
      searchText: '',
      loader: false,
      isDataEmpty: true,
      data: [],
      totalRecords: 0,
      isButtonDisabled: false,
      toggleGraph: false,
      graphUrl: '',
      selectedYear: new Date().getFullYear() - 1,
      queryId: "",
      groups: [],
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.debouceTimeout = null;
  }

  componentDidMount() {
    BoxUtitlizationFilterObj.group_id = sessionStorage.getItem("groupID")
    this.fetchSuggestions();
    this.BindBoxUtilization();
    this.fetchGraph();
  }

  onSearchChange(event) {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchText: searchString && searchString });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.sortOrder = 'desc';
    BoxUtitlizationFilterObj.sortColumn = 'created_on';
    BoxUtitlizationFilterObj.tableName = '';
    BoxUtitlizationFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindBoxUtilization();
    }, 1000)
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en'
      ? date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('MM/DD/YYYY hh:mm:ss A')
      : date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('DD/MM/YYYY hh:mm:ss A');
  };

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/KioskUtilizationReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(BoxUtitlizationFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRow = [];
        let Elements = [
          [
            'Id',
            'Store',
            'Box',
            'Total Bins',
            'Available Bins',
            'Use Bins',
            'Stocked Bins',
            'Utilization',
            'Date',
          ],
        ];
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Elements.push([
                i.store,
                i.box,
                i.total_bins,
                i.available_bins,
                i.use_bins,
                i.stock_bins,
                i.box_utilization ? i.box_utilization + '%' : '',
                i.utilization_date
                  ? this.convertToTimeZone(i && i.utilization_date)
                  : '',
              ]);
            }

            for (let i of Elements) {
              csvRow.push(i.join(','));
            }
            let csvString = csvRow.join('%0A');
            let element = document.createElement('a');
            element.href = 'data:attachment/csv.' + csvString;
            element.target = '_Blank';
            element.download = 'KioskUtilizationReport.csv';
            document.body.appendChild(element);
            element.click();
          }
        }
      });
  }

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['box'].includes(field)) {
      tablename = 'boxes';
    }
    if (['store'].includes(field)) {
      tablename = 'accounts';
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ order, orderBy, sortId: property });
    BoxUtitlizationFilterObj.sortOrder = order;
    BoxUtitlizationFilterObj.sortColumn = field;
    BoxUtitlizationFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindBoxUtilization();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    BoxUtitlizationFilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindBoxUtilization();
    }
  };

  handleChangeRowsPerPage = (event) => {
    const { data } = this.state;
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindBoxUtilization();
    }
  };

  BindBoxUtilization() {
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + 'kioskBoxUtilization', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(BoxUtitlizationFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({ totalRecords: uData && uData.total });
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({
            data: uData && uData.results,
            loader: uData && uData.total && false,
            isDataEmpty: false,
            isButtonDisabled: false,
          });
        } else {
          this.setState({
            data: null,
            loader: false,
            isDataEmpty: true,
            isButtonDisabled: true,
          });
        }
      });
  }

  fetchGraph(isEmailRequested = false) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'kioskBoxUtilizationGraph', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        currentYear: this.state.selectedYear,
        isEmailRequested,
      }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({ loader: false, graphUrl: uData && uData.graphUrl });
      })
      .catch((reason) => {
        this.setState({ loader: false });
        console.error(reason);
      });
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    BoxUtitlizationFilterObj.group_id = event.target.value
    this.BindBoxUtilization();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const { classes, t } = this.props;
    const {
      data,
      totalRecords,
      searchText,
      isButtonDisabled,
      toggleGraph,
      graphUrl,
      queryId, groups
    } = this.state;
    return (
      <Paper>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <div>
          {toggleGraph ? (
            <React.Fragment>
              <div
                style={{
                  margin: '10px',
                  display: 'flex',
                  alighItem: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Button
                  style={{
                    width: '15%',
                    borderBottom: 'none',
                  }}
                  onClick={() => {
                    this.setState({ toggleGraph: false });
                  }}
                >
                  Table View
                </Button>
                <Button
                  style={{
                    width: '15%',
                    borderBottom: 'none',
                  }}
                  onClick={() => {
                    this.fetchGraph(true);
                  }}
                >
                  Email Graph
                </Button>
              </div>
              <img src={graphUrl} alt='' />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div>
                <Table className={classes.table} aria-labelledby='tableTitle'>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          width: '15%',
                          borderBottom: 'none',
                        }}
                      >
                        <Button
                          onClick={() => {
                            this.setState({ toggleGraph: true });
                          }}
                        >
                          Graph View
                        </Button>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <TextField
                          id='idsearchtxt'
                          className={classes.formControl}
                          defaultValue=''
                          value={searchText}
                          label={t('Report.KioskUtil.Search')}
                          onChange={this.onSearchChange}
                          fullWidth
                          inputProps={{
                            autocomplete: 'new-search',
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          variant='standard'
                        />
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <FormControl
                          variant='standard'
                          sx={{ m: '16px 0', minWidth: 347 }}
                        >
                          <InputLabel id='preferred-group-label'>
                            {t('Group.User.GroupControlTitle')}
                          </InputLabel>
                          <Select
                            labelId='preferred-group-label'
                            id='preferred-group-select-standard'
                            value={queryId}
                            onChange={this.handleInputChange}
                            variant='standard'
                            label={t('Group.User.GroupControlTitle')}
                          >
                            {groups.length > 0 &&
                              groups.map((type, index) => (
                                <MenuItem
                                  key={index}
                                  value={type.id}
                                  className={classes.locationType}
                                >
                                  {type.name}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell
                        style={{
                          width: '25%',
                          borderBottom: 'none',
                          textAlign: 'right',
                        }}
                      >
                        <Tooltip
                          title={t('Report.KioskUtil.ExportCSVTooltip')}
                          style={{ marginRight: '0' }}
                          aria-label='ExportCSV'
                        >
                          <IconButton disabled={isButtonDisabled}>
                            <img
                              alt='download'
                              src={download}
                              onClick={() => this.exportCSV()}
                              style={{
                                height: '32px',
                                width: '32px',
                                cursor: 'pointer',
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
              <Divider style={{ marginTop: '10px', height: '5px' }} />
              <div className={classes.tableWrapper}>
                <Table className={classes.table} aria-labelledby='tableTitle'>
                  <EnhancedTableHead
                    order={BoxUtitlizationFilterObj.sortOrder}
                    orderBy={BoxUtitlizationFilterObj.sortColumn}
                    sortId={this.state.sortId}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {!data ? (
                      <TableRow>
                        <TableCell
                          colSpan={8}
                          style={{ textAlign: 'center', padding: '10px 0px' }}
                        >
                          {this.state.isDataEmpty &&
                            t('Report.KioskUtil.NoDataFoundText')}
                        </TableCell>
                      </TableRow>
                    ) : (
                      data &&
                      data.length > 0 &&
                      stableSort(
                        data,
                        getSorting(
                          BoxUtitlizationFilterObj.sortOrder,
                          BoxUtitlizationFilterObj.sortColumn
                        )
                      ).map((n) => {
                        return (
                          <TableRow sx={{ height: '50px' }}>
                            <TableCell className={classes.padding10px}>
                              {' '}
                              {n && n.store}{' '}
                            </TableCell>
                            <TableCell className={classes.padding10px}>
                              {' '}
                              {n && n.box}{' '}
                            </TableCell>
                            <TableCell className={classes.padding10px}>
                              {' '}
                              {n && n.total_bins}{' '}
                            </TableCell>
                            <TableCell className={classes.padding10px}>
                              {' '}
                              {n && n.available_bins}
                            </TableCell>
                            <TableCell className={classes.padding10px}>
                              {' '}
                              {n && n.use_bins}{' '}
                            </TableCell>
                            <TableCell className={classes.padding10px}>
                              {' '}
                              {n && n.stock_bins}
                            </TableCell>
                            <TableCell className={classes.padding10px}>
                              {' '}
                              {n && n.box_utilization + '%'}
                            </TableCell>
                            <TableCell className={classes.padding10px}>
                              {' '}
                              {n && n.utilization_date
                                ? this.convertToTimeZone(
                                  n && n.utilization_date
                                )
                                : ''}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableBody>
                </Table>
              </div>
              <ThemeProvider theme={localeTheme}>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component='div'
                  count={totalRecords || 0}
                  rowsPerPage={BoxUtitlizationFilterObj.pageSize}
                  page={BoxUtitlizationFilterObj.pageNo}
                  backIconButtonProps={{
                    'aria-label': 'Previous Page',
                  }}
                  nextIconButtonProps={{
                    'aria-label': 'Next Page',
                  }}
                  onPageChange={this.handleChangePage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
              </ThemeProvider>
            </React.Fragment>
          )}
        </div>
      </Paper>
    );
  }
}

KioskBoxUtilization.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(KioskBoxUtilization));



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/index.js